import type { ReportLayoutConfig } from '@/features/reports'

// v3 `configs/Audience/FunnelExploration.js` (47 ln) — retyped, with defect D31 (analysis 24
// §D31) fixed in the port: v3 declared FOUR sections under ONE id
// (`funnel_exploration__fallout_funnel`, `:6,14,22,30`) — duplicate DOM anchors, so the
// open/close/baseline deep links never worked distinctly. Each section now owns its id;
// `fallout_funnel` stays on the one section whose title matched it, and
// `daily_breakdown` is verbatim.
//
// Every section is `pending`: the funnel body is bespoke (FunnelApi + store + chart —
// ORP-18913). v3's config carried no schedule-tab bindings for the funnel (the page
// resolves its tabs from custom-analysis metadata at runtime, `FunnelExploration.vue:187`),
// so no section here binds one. The four funnel modes are VIEW MODES of
// `FunnelExplorationFunnelChart.vue`, not four components; Daily Breakdown is
// `FunnelExplorationLineCharts.vue`.
//
// `reportId: 23` is the v3 config value, kept verbatim. OPEN QUESTION (contract 24 §18.9,
// blocking for the page ticket, not for this data port): the v3 RUNTIME uses report 56
// everywhere (`getScheduleByReportId(56)`, `FunnelExploration.vue:187`) while the config and
// the date picker say 23, and v3's link-map routes BOTH here. ORP-18913 must resolve the id
// (interim per contract: gate the page on [23, 56]) — do not treat 23 as settled.
// v3 `importance`/`search_value` blobs are dropped — search-index metadata with no v4
// section-level home (same decision as every 08 seed and module 27's configs; module 15 pending).

const FUNNEL_EXPLORATION_REPORT_ID = 23

function funnelSection(id: string, name: string, titleKey: string, pendingNote: string) {
  return {
    id,
    kind: 'pending' as const,
    pendingNote,
    titleKey,
    reportId: FUNNEL_EXPLORATION_REPORT_ID,
    tabs: [{ name }],
  }
}

export const FUNNEL_EXPLORATION: ReportLayoutConfig = [
  {
    name: 'Overview',
    labelKey: 'audience.funnelExploration.tabs.overview',
    sections: [
      funnelSection(
        'funnel_exploration__open_funnel',
        'Open Funnel',
        'audience.funnelExploration.sections.openFunnel',
        'v3 component → FunnelExplorationFunnelChart, open mode (ORP-18913)',
      ),
      funnelSection(
        'funnel_exploration__close_funnel',
        'Close Funnel',
        'audience.funnelExploration.sections.closeFunnel',
        'v3 component → FunnelExplorationFunnelChart, close mode (ORP-18913)',
      ),
      funnelSection(
        'funnel_exploration__fallout_funnel',
        'Fallout Funnel',
        'audience.funnelExploration.sections.falloutFunnel',
        'v3 component → FunnelExplorationFunnelChart, fallout mode (ORP-18913)',
      ),
      funnelSection(
        'funnel_exploration__baseline_funnel',
        'Baseline Funnel',
        'audience.funnelExploration.sections.baselineFunnel',
        'v3 component → FunnelExplorationFunnelChart, baseline mode (ORP-18913)',
      ),
      funnelSection(
        'funnel_exploration__daily_breakdown',
        'Daily Breakdown',
        'audience.funnelExploration.sections.dailyBreakdown',
        'v3 component → FunnelExplorationLineCharts (ORP-18913)',
      ),
    ],
  },
]
